// @ts-nocheck

import { EnvironmentDetector } from '../../../../shared/Environment/EnvironmentDetector';
import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

const MicroFrontendsConfig = new ReduxAsyncAction('MICRO_FRONTEND_CONFIG');
MicroFrontendsConfig.registerRequest(async () => {
  const response = await dash_api.get(`/v1/micro-frontends/config`);

  return response.data;
});

export const getMicroFrontendsConfig = MicroFrontendsConfig.request;
export const MICRO_FRONTENDS_CONFIG = MicroFrontendsConfig.constants;

const MicroFrontendsVersions = new ReduxAsyncAction('MICRO_FRONTEND_VERSIONS');
MicroFrontendsVersions.registerRequest(async () => {
  const env = new EnvironmentDetector().detect();

  if (!env && new URL(window.location.href).hostname === 'localhost') {
    return null;
  }

  const response = await dash_api.get(`/v1/micro-frontends/versions?env=${env}`);

  return response.data;
});

export const getMicroFrontendVersions = MicroFrontendsVersions.request;
export const MICRO_FRONTEND_VERSIONS = MicroFrontendsVersions.constants;
